export var slugify = function (text) {
    return text
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/^\/|/g, '')
        .replace(/\s+/g, '-')
        .replace(/[^\w-/\\?=&+]+/g, '')
        .replace(/--+/g, '-');
};
export var uppercasefy = function (text) {
    return text
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '_');
};
export var formatDate = function (date) {
    var month = '' + (date.getMonth() + 1), day = '' + date.getDate();
    var year = date.getFullYear();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    //  returns the date on format  YYYY-MM-DD
    return [year, month, day].join('-');
};
export var titleCasify = function (text) {
    return text.replace(/^[-_]*(.)/, function (_, c) { return c.toUpperCase(); }).replace(/[-_]+(.)/g, function (_, c) { return ' ' + c.toUpperCase(); });
};
export var parseInitialValue = function (input) {
    if (typeof input === 'number') {
        return input.toString();
    }
    else if (typeof input === 'string') {
        return input;
    }
    return '';
};
//# sourceMappingURL=utils.js.map